// src/features/reporting/hooks/useReports.js
import { useState, useEffect, useCallback } from 'react';
import { useApi } from '../../../hooks/api/useApi';
import { reportingAPI } from '../services/reporting';

export function useReports() {
  const { loading: typesLoading, error: typesError, execute, clearError } = useApi();
  const { loading: generateLoading, error: generateError, execute: executeGenerate, clearError: clearGenerateError } = useApi();
  const [reportTypes, setReportTypes] = useState([]);
  const [generatingType, setGeneratingType] = useState(null);

  const loadReportTypes = useCallback(async () => {
    const result = await execute(() => reportingAPI.getReportTypes());
    if (result.success) {
      setReportTypes(result.data?.data?.report_types ?? []);
    }
  }, [execute]);

  useEffect(() => {
    loadReportTypes();
  }, [loadReportTypes]);

  const downloadReport = useCallback(async (reportType, displayName) => {
    setGeneratingType(reportType);
    const result = await executeGenerate(() => reportingAPI.generateReport(reportType));
    setGeneratingType(null);

    if (result.success) {
      const blob = new Blob([result.data], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `${reportType}_${new Date().toISOString().slice(0, 10)}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    }
  }, [executeGenerate]);

  return {
    reportTypes,
    loading: typesLoading,
    error: typesError,
    clearError,
    generateLoading,
    generateError,
    clearGenerateError,
    generatingType,
    downloadReport,
    refresh: loadReportTypes,
  };
}
